import './style.css';

const PriceCard = ({img, title, price, duration, description_1, description_2, description_3}) => {
  return ( 
    <div className="price__card">
      <div className="price__card-img">
        <img src={img} alt={title} className="price-img" />
      </div>
      <div className="price__card-text">
        <h2 className="price__card-title">{title}</h2>
        <ul className="price__card-bullets flow">
          <li>{duration}</li>
          <li>{description_1}</li>
          <li>{description_2}</li>
          <li>{description_3}</li>
          <b><li>{price}</li></b>
        </ul>
      </div>
    </div>
   );
}
 
export default PriceCard;